<template>
  <div v-if="home" class="home">
    <common-hero
      v-if="home.coverDesk"
      :background="{
        desktop: home.coverDesk.responsiveImage.src,
        mobile:
          home.coverMobile && home.coverMobile.responsiveImage
            ? home.coverMobile.responsiveImage.src
            : home.coverDesk.responsiveImage.src,
      }"
      :tag="'div'"
      :scroll="true"
      style="height: 100vh"
    >
      <h1
        class="hero-bigger-title"
        v-html="
          home && home.title !== '' ? home.title.replace(/\n/g, '<br>') : ''
        "
      />
      <p
        v-html="
          home && home.subtitle !== ''
            ? home.subtitle.replace(/\n/g, '<br>')
            : ''
        "
      />
    </common-hero>
    <template v-if="home && home.videoHd !== ''">
      <div class="video-header" ref="video">
        <video
          :key="home.videoHd"
          class="inner setResolution autoplay"
          preload="none"
          loop
          playsinline
          muted
          autoplay
          is-playing="false"
          data-object-fit="cover"
          hasaudio="false"
          style="
            width: 100%;
            height: 100%;
            -o-object-fit: cover;
            object-fit: cover;
            background-color: #000;
            left: 0;
            top: 0;
          "
        >
          <source :src="home.videoHd" />
          <source :src="home.video720" media="all and (max-width:1280px)" />
          <source :src="home.video540" media="all and (max-width:960px)" />
          <source :src="home.video360" media="all and (max-width:640px)" />
        </video>
      </div>
    </template>
    <!--<section class="paragrafo-come-funziona fiera-banner --grey">
      <img :src="'/home/fiera-febbraio.png'" />
    </section>-->
    <section class="paragrafo-come-funziona padding-paragrafo --grey">
      <div v-animate-on-intersection class="default-container">
        <div v-html="home.paragraph" />
        <ul v-if="home.iconTabs && home.iconTabs.length > 0" class="icons-set">
          <li v-for="(item, index) in home.iconTabs" :key="index">
            <div>
              <img :src="item.svg.url" :alt="item.text" />
              <span class="text-to-uppercase">{{ item.text }}</span>
            </div>
          </li>
        </ul>
        <LinkCta
          :to="{ name: `${lang}-come-funziona`, params: { lang } }"
          :label="$t('comeFunzionaCTA')"
        />
      </div>
    </section>
    <section
      class="padding-paragrafo paragrafo-h-p font-white"
      style="padding-top: 0"
    >
      <div
        v-if="home.imageBiocharDesk || home.imageBiocharMobile"
        :style="
          viewport.label === 'mobile' && home.imageBiocharMobile
            ? `background-color: #343434; background-image: url('${home.imageBiocharMobile.responsiveImage.src}'); background-position: bottom center; background-size: cover;`
            : `background-color: #343434; background-image: url('${home.imageBiocharDesk.responsiveImage.src}'); background-position: bottom center; background-size: cover;`
        "
        class="padding-paragrafo paragrafo-h-p font-white"
      >
        <div v-animate-on-intersection class="default-container">
          <h3 class="text-to-uppercase">{{ home.introBiochar }}</h3>
          <p
            v-if="home && home.textBiochar !== ''"
            v-html="home.textBiochar.replace(/\n/g, '<br>')"
          />
          <LinkCta
            :to="{ name: `${lang}-biochar`, params: { lang } }"
            :label="$t('biocharCTA')"
          />
        </div>
      </div>
    </section>
    <section
      v-if="home.imageImpiantoDesk || home.imageImpiantoMobile"
      :style="
        viewport.label === 'mobile' && home.imageImpiantoMobile
          ? `background-color: #343434; background-image: url('${home.imageImpiantoMobile.responsiveImage.src}'); background-position: bottom center; background-size: cover;`
          : `background-color: #343434; background-image: url('${home.imageImpiantoDesk.responsiveImage.src}'); background-position: bottom center; background-size: cover;`
      "
      class="padding-paragrafo paragrafo-h-p font-white"
    >
      <div v-animate-on-intersection class="default-container">
        <h3 class="text-to-uppercase">{{ home.introImpianto }}</h3>
        <p
          v-if="home && home.textImpianto !== ''"
          v-html="home.textImpianto.replace(/\n/g, '<br>')"
        />
        <LinkCta
          :to="{ name: `${lang}-impianto`, params: { lang } }"
          :label="$t('impiantoCTA')"
        />
      </div>
    </section>
    <section
      v-if="vantaggi"
      class="padding-paragrafo paragrafo-h-p hasUl font-black"
    >
      <div v-animate-on-intersection class="default-container">
        <h3 class="text-to-uppercase">
          {{ vantaggi.introHomepage }}
        </h3>
        <div v-html="vantaggi.titleHomepage" />
        <ul>
          <li
            v-for="(item, index) in vantaggi.listBenefit"
            :key="index"
            v-html="item.elementoLista"
          />
        </ul>
        <LinkCta
          :to="{ name: `${lang}-vantaggi`, params: { lang } }"
          :label="vantaggi.labelCta"
        />
      </div>
    </section>
  </div>
</template>

<script>
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import LinkCta from '@/components/LinkCta'
import CommonHero from '@/components/CommonHero'

import { mapGetters } from 'vuex'

import { vantaggiHome } from '@/queries/vantaggi.js'
import { home } from '@/queries/home.js'

export default {
  mixins: [lang, dataLoad],
  name: 'home',
  components: {
    CommonHero,
    LinkCta
  },
  data: () => ({
    vantaggi: {},
    home: {},
    seo: {}
  }),
  apollo: {
    vantaggi: {
      query: vantaggiHome,
      fetchPolicy: 'cache-and-network',
      prefetch: true,
      variables () {
        return {
          locale: this.$i18n.locale
        }
      },
      result (result) {
        if (result.data) {
          this.vantaggi = result.data.vantaggi
        }
      }
    },
    home: {
      query: home,
      fetchPolicy: 'cache-and-network',
      prefetch: true,
      variables () {
        return {
          locale: this.$i18n.locale
        }
      },
      result (result) {
        if (result.data) {
          this.home = result.data.home
          this.seo = this.home.seo
        }
      }
    }
  },
  computed: {
    ...mapGetters(['viewport']),
    imgServer: {
      get () {
        return process.env.VUE_APP_ENDPOINT
      }
    },
    bgImage: {
      get () {
        return `${this.imgServer}${
          this.pageApiData.coverImpianto[this.viewport.label]
        }`
      }
    },
    getBackgroundCss: {
      get () {
        return `background-color: #EFEFEC; background-image: url('${this.bgImage}'); background-position: center center; background-size: cover;`
      }
    }
  }
}
</script>

<style lang="scss">
@import "../assets/mixins/breakpoints";
@import "../assets/mixins/typo";
@import "../assets/mixins/common";

.home {
  background-color: #fff;

  .listing-internal-pages {
    padding-top: 4rem;
    padding-bottom: 4rem;
    @media #{$medium_mq} {
      padding-top: 4rem;
      padding-bottom: 6rem;
    }
    @media #{$large_mq} {
      padding-bottom: 8rem;
    }
    @media #{$xlarge_mq} {
      padding-bottom: 10rem;
    }
  }
}

.home .listing-lavorazioni .listing-lavorazioni__content.hide-for-medium p {
  display: none;
}

.home .listing-lavorazioni.listing-lavorazioni--gallery {
  cursor: grab;
}

.video-header {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.video-header video {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  background-color: #000;
  position: absolute;
}

.paragrafo-come-funziona {
  p {
    font-size: 2rem;
    line-height: 1.1;

    color: #343434;
    font-family: "IBM Plex Sans Condensed", sans-serif;
    font-weight: 300;

    @media #{$medium_mq} {
      font-size: 2.7rem;
    }
    @media #{$large_mq} {
      font-size: 3.35rem;
    }
    @media #{$xlarge_mq} {
      font-size: 3.85rem;
    }
    @media #{$xxlarge_mq} {
      font-size: 4.375rem;
    }

    strong {
      font-weight: 600px;
    }
  }
}

.icons-div-set ul {
  display: grid;
  overflow: hidden;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  grid-column-gap: 25px;
  grid-row-gap: 25px;
  width: 100%;
  /* align-items: baseline; */
  margin-top: 80px;
  margin-bottom: 95px;
  @media #{$large_mq} {
    grid-template-columns: repeat(4, 1fr);
    margin-top: 100px;
    margin-bottom: 120px;
  }
  li {
    justify-items: stretch;
    padding: 52px 0;
    background-color: #fff;
    display: block;
    text-align: center;
    img {
      margin-bottom: 40px;
    }
    span {
      width: 100%;
      display: block;
      font-size: 0.9rem;
      font-family: "IBM Plex Mono", sans-serif;
      font-weight: 400;
      text-transform: uppercase;
      color: #343434;
      padding: 0 20px;
      @media #{$medium_mq} {
        font-size: 0.95rem;
      }
      @media #{$large_mq} {
        font-size: 1.05rem;
      }
      @media #{$xlarge_mq} {
        font-size: 1.15rem;
      }
      @media #{$xxlarge_mq} {
        font-size: 1.25rem;
      }
    }
  }
}

.paragrafo-h-p {
  background-color: #efefec;
  h1,
  h2,
  h3,
  h4,
  h5 {
    margin: 0 0 30px;
    @media #{$large_mq} {
      margin: 0 0 35px;
    }
    @media #{$xlarge_mq} {
      margin: 0 0 40px;
    }
  }
  p {
    @include section-paragraph(#fff);
    margin: 0 0 90px;
    @media #{$large_mq} {
      margin: 0 0 140px;
    }
    @media #{$xlarge_mq} {
      margin: 0 0 180px;
    }
  }
  &.hasUl {
    p {
      padding-bottom: 30px;
      margin-bottom: 0px;
      @media #{$large_mq} {
        margin: 0 0 60px;
      }
      @media #{$xlarge_mq} {
        margin: 0 0 90px;
      }
    }
  }
  ul {
    margin: 0 0 40px;
    @media #{$large_mq} {
      margin: 0 0 70px;
    }
    @media #{$xlarge_mq} {
      margin: 0 0 100px;
    }
    li {
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate3d(0, -50%, 0);
        background-image: url("data:image/svg+xml,%3Csvg width='55px' height='55px' viewBox='0 0 55 55' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 57 (83077) - https://sketch.com --%3E%3Ctitle%3ERaggruppa 535%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Raggruppa-535'%3E%3Crect id='Rettangolo_466' fill='%23FFFFFF' fill-rule='nonzero' x='0' y='0' width='55' height='55'%3E%3C/rect%3E%3Cg id='check_copy_6' transform='translate(14.535000  16.589000)' stroke='%23343434' stroke-width='1.5'%3E%3Cg id='Group_5'%3E%3Cpolyline id='Fill_1' points='0.465 12.362 9.315 21.412 26.465 0.412'%3E%3C/polyline%3E%3Cpolyline id='Stroke_3' points='0.465 12.362 9.315 21.412 26.465 0.412'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        background-size: cover;
        width: 20px;
        height: 20px;
        @media #{$large_mq} {
          width: 55px;
          height: 55px;
        }
      }
      padding: 15px 0 15px 40px;
      @media #{$large_mq} {
        padding: 20px 0 20px 77px;
      }
      margin: 10px 0;
    }
  }
  &.paragrafo-h-p--greener {
    li {
      &:before {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='31' height='31' viewBox='0 0 31 31'%3E%3Cg id='Raggruppa_382' data-name='Raggruppa 382' transform='translate(-204 -4875)'%3E%3Crect id='Rettangolo_465' data-name='Rettangolo 465' width='31' height='31' transform='translate(204 4875)' fill='%2330ae8d'/%3E%3Cg id='check_copy_6' data-name='check copy 6' transform='translate(212.455 4884.582)'%3E%3Cg id='Group_5' data-name='Group 5' transform='translate(0 0)'%3E%3Cpath id='Fill_1' data-name='Fill 1' d='M0 6.735l4.988 5.1L14.655 0' fill='none' stroke='%23343434' stroke-width='1.5'/%3E%3Cpath id='Stroke_3' data-name='Stroke 3' d='M0 6.735l4.988 5.1L14.655 0' fill='none' stroke='%23343434' stroke-width='1.5'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        background-size: cover;
        width: 20px;
        height: 20px;
        top: 0;
        transform: translate3d(0, 22px, 0);
        @media #{$large_mq} {
          width: 55px;
          height: 55px;
        }
      }

      padding: 15px 0 15px 40px;
      @media #{$large_mq} {
        padding: 20px 0 20px 77px;
      }

      strong {
        color: #30ae8d;
      }

      p {
        @media #{$large_mq} {
          margin-bottom: 20px;
        }
      }
    }
  }
}
.paragrafo-h-p.font-white {
  h1,
  h2,
  h3,
  h4,
  h5 {
    @include section-title(#fff);
  }
  p {
    @include section-paragraph(#fff);
  }
  ul li {
    @include hero-small-p(#fff);
  }
}
.paragrafo-h-p.font-black {
  h1,
  h2,
  h3,
  h4,
  h5 {
    @include section-title(#343434);
  }
  p {
    @include section-paragraph(#343434);
  }
  ul li {
    @include hero-small-p(#343434);
  }
  ul li p {
    @include hero-small-p(#343434);
    margin: 0;
    padding-bottom: 0;
  }
}

.fiera-banner.--grey {
  background: #efefec 0% 0% no-repeat padding-box;
}

.fiera-banner img {
  padding: 100px 1.925rem 0;
  display: block;
  margin: auto;
  max-width: 100%;
  @media #{$small_mq} {
    padding: 50px 1.925rem 0;
  }
}
</style>
